/*@flow*/
import type { Node, Element } from "react";
import React from "react";
import CreateIssueButton from "comps/StreetscapeAsset/CreateIssueButton";
import IssueList from "comps/StreetscapeAsset/IssueList";
import CreateEventButton from "comps/Event/CreateEventButton";
import EventList from "comps/Event/List";
import canViewAsset from "lib/canViewAsset";
import isEmbedded from "lib/isEmbedded";
import CreateTenantButton from "comps/Unit/CreateTenantButton";
import TenantList from "comps/Unit/TenantList";

const TenantSubsection = (props: { id: ID }): Element<"div"> => {
  return (
    <div data-testid="TenantSubresource" className="pt-3">
      <EventList tenantId={props.id} />
      <CreateEventButton
        id={null}
        tenantId={props.id}
        className="btn btn-primary"
        title="Create Event"
      />
    </div>
  );
};

const ListingSubsection = (props: { id: ID , resourceType: String }): Element<"div"> => {
  return (
    <div data-testid="ContactSubresource" className="pt-3">
      <EventList listingId={props.id} />
      <CreateEventButton
        id={null}
        resourceId={props.id}
        resourceType={props.resourceType}
        className="btn btn-primary"
        title="Create Event"
      />
    </div>
  );
};

const PropertySubsection = (props: { id: ID , resourceType: String }): Element<"div"> => {
  return (
    <div data-testid="PropertySubsection" className="pt-3">
      <EventList listingId={props.id} />
      <CreateEventButton
        id={null}
        resourceId={props.id}
        resourceType={props.resourceType}
        className="btn btn-primary"
        title="Create Event"
      />
    </div>
  );
};

const ContactSubsection = (props: { id: ID , resourceType: String }): Element<"div"> => {
  return (
    <div data-testid="ContactSubsection" className="pt-3">
      <EventList listingId={props.id} />
      <CreateEventButton
        id={null}
        resourceId={props.id}
        resourceType={props.resourceType}
        className="btn btn-primary"
        title="Create Event"
      />
    </div>
  );
};

const StreetscapeAssetSubsection = (props: { id: ID }): Element<"div"> => (
  <div data-testid="StreetscapeAssetSubresource" className="pt-3">
    <IssueList streetscapeAssetId={props.id} />
    <CreateIssueButton
      id={null}
      streetscapeAssetId={props.id}
      className="btn btn-primary"
      title="Create Issue"
    />
  </div>
);

const UnitSubsection = (props: { id: ID }): Element<"div"> => {
  return (
    <div data-testid="UnitSubresource" className="pt-3">
      <TenantList unitId={props.id} />
      <CreateTenantButton
        id={null}
        unitId={props.id}
        className="btn btn-primary"
        title="Create Tenant"
      />
    </div>
  );
};

export const subresourceCompMap = {
  StreetscapeAsset: StreetscapeAssetSubsection,
  Development: null,
  Listing: ListingSubsection,
  StreetscapeIssue: null,
  Tenant: TenantSubsection,
  Unit: UnitSubsection,
  Event: null,
  Property: PropertySubsection,
  Building: null,
  Contact: ContactSubsection,
};

export default ({
  resourceName,
  resourceId,
}: {
  resourceId: ID,
  resourceName: string,
}): null | Node => {
  const Comp = subresourceCompMap[resourceName];
  if (!Comp) return null;
  if (!canViewAsset()) return null;
  if (isEmbedded()) return null;
  return <Comp id={resourceId} resourceType={resourceName} />;
};
